import React from "react";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../redux/store";
import { PickerFieldWrapper } from "./PickerFieldWrapper";
import { RootStackParamList } from "../../types/navigationParams";
import {Field} from "../../config/companies/config";

interface StatusFieldProps {
  field: Field;
  value: string;
  onChange: (fieldName: string, newValue: any) => void;
  errors?: { [key: string]: string };
}

export const StatusField = ({
  field,
  value,
  onChange,
  errors = {},
}: StatusFieldProps) => {
  const { t } = useTranslation();
  const navigate = useNavigation<NavigationProp<RootStackParamList>>();
  const role = useAppSelector((state) => state.auth.user.role);

  const handleChangeDropdown = (newValue: string | string[]) => {
    onChange(field.name, newValue);
  };

  const onPressStatusPicker = () => {
    navigate.navigate("PickerScreen", {
      options:
        field.statusOptions
          ?.filter((item) => item.editableBy.includes(role))
          .map((i) => i.value) || [],
      onValueChange: handleChangeDropdown,
      disableSearch: false,
    });
  };

  return (
    <PickerFieldWrapper
      field={field}
      value={value}
      onChange={onChange}
      onPress={onPressStatusPicker}
      errors={errors}
      displayValue={t(value)}
    />
  );
};
